import { Request } from "../../request";
import { getURL } from "../../utils";

// seller products
export const get_seller_products = (
  product_id = null,
  site_id = null,
  paginate = null,
  page = null,
  limit = null,
  search = null,
  brand_id = null,
  category_id = null,
  is_active = null,
  city_id = null,
  seller_id = null
) => {
  return Request.get(getURL(`/api/corporation-pa/sellers/products/`), {
    product_id,
    site_id,
    paginate,
    page,
    limit,
    search,
    brand_id,
    category_id,
    is_active,
    city_id,
    seller_id,
  });
};

export const get_export_seller_products = (
  product_id = null,
  site_id = null,
  search = null,
  brand_id = null,
  category_id = null,
  is_active = null,
  city_id = null,
  seller_id = null
) => {
  return Request.rawGet(getURL(`/api/corporation-pa/sellers/products/export/`), {
    product_id,
    site_id,
    search,
    brand_id,
    category_id,
    is_active,
    city_id,
    seller_id,
  });
};

export const put_import_seller_products = (data) => {
  return Request.formPut(getURL(`/api/corporation-pa/sellers/products/import/`), data);
};

export const post_seller_product = (data) => {
  return Request.post(getURL(`/api/corporation-pa/sellers/products/`), data);
};

export const put_seller_product = (seller_product_id, data) => {
  return Request.put(
    getURL(`/api/corporation-pa/sellers/products/${seller_product_id}/`),
    data
  );
};
